import { Routes, Route } from 'react-router-dom'
import { Helmet } from 'react-helmet-async'
import { useSelector, useDispatch } from 'react-redux'
import { RootState } from './store'
import { hideLoginModal } from './store/features/user/userSlice'
import Layout from './components/Layout/Layout'
import PWAUpdatePrompt from './components/PWA/PWAUpdatePrompt'
import Home from './pages/Home/Home'
import Products from './pages/Products/Products'
import Solutions from './pages/Solutions/Solutions'
import About from './pages/About/About'
import News from './pages/News/News'
import Investment from './pages/Investment/Investment'
import Careers from './pages/Careers/Careers'
import JobApplication from './pages/Careers/JobApplication'
import Contact from './pages/Contact/Contact'
import UserCenter from './pages/UserCenter/UserCenter'
import UserProfile from './pages/UserCenter/UserProfile'
import UserSettings from './pages/UserCenter/UserSettings'
import OfflinePage from './pages/OfflinePage/OfflinePage'
import LoginModal from './components/Auth/LoginModal'
import NetworkStatus from './components/PWA/NetworkStatus'
import NewsDetail from './pages/NewsDetail/NewsDetail'
import ProductDetail from './pages/ProductDetail/ProductDetail'
import SolutionDetail from './pages/SolutionDetail/SolutionDetail'
import AdminDashboard from './pages/AdminDashboard/AdminDashboard'
import PrivacyPolicy from './pages/Legal/PrivacyPolicy'
import TermsOfService from './pages/Legal/TermsOfService'
import CookiePolicy from './pages/Legal/CookiePolicy'
import LegalNotice from './pages/Legal/LegalNotice'
import HelpCenter from './pages/Support/HelpCenter'
import HelpDetail from './pages/Support/HelpDetail'
import TechnicalDocs from './pages/Support/TechnicalDocs'
import APIDocs from './pages/Support/APIDocs'
import Community from './pages/Support/Community'
import Feedback from './pages/Support/Feedback'
import NotFound from './pages/NotFound/NotFound'

// AppContent组件处理Redux状态
function AppContent() {
  const dispatch = useDispatch()
  const { showLoginModal } = useSelector((state: RootState) => state.user)

  return (
    <>
      <Helmet>
        <title>DeepLink Limited - CoreTrust手机 | Web3深度集成设备</title>
        <meta name="description" content="DeepLink Limited专注于Web3深度集成的硬件设备，CoreTrust手机提供熄屏广告、空投助手、数字银行、硬件钱包等完整Web3解决方案。" />
        <meta name="keywords" content="Web3,区块链,CoreTrust,DeepLink,硬件钱包,DeFi,数字货币" />
        <meta property="og:title" content="DeepLink Limited - CoreTrust手机" />
        <meta property="og:description" content="转账别害怕，地址打电话 - 基于Web3深度集成的智能手机" />
        <meta property="og:type" content="website" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        
        {/* PWA相关meta标签 */}
        <meta name="theme-color" content="#3b82f6" />
        <meta name="apple-mobile-web-app-capable" content="yes" />
        <meta name="apple-mobile-web-app-status-bar-style" content="default" />
        <meta name="apple-mobile-web-app-title" content="DeepLink" />
        <meta name="msapplication-TileColor" content="#3b82f6" />
        <meta name="msapplication-config" content="/browserconfig.xml" />
        
        {/* 预加载关键资源 */}
        <link rel="preload" href="/fonts/inter-var.woff2" as="font" type="font/woff2" crossOrigin="anonymous" />
      </Helmet>
      
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/products" element={<Products />} />
          <Route path="/products/:slug" element={<ProductDetail />} />
          <Route path="/solutions" element={<Solutions />} />
          <Route path="/solutions/:id" element={<SolutionDetail />} />
          <Route path="/about" element={<About />} />
          <Route path="/news" element={<News />} />
          <Route path="/news/:id" element={<NewsDetail />} />
          <Route path="/investment" element={<Investment />} />
          <Route path="/careers" element={<Careers />} />
          <Route path="/careers/apply/:id" element={<JobApplication />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/user" element={<UserCenter />} />
          <Route path="/user/profile" element={<UserProfile />} />
          <Route path="/user/settings" element={<UserSettings />} />
          <Route path="/offline" element={<OfflinePage />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<TermsOfService />} />
          <Route path="/cookies" element={<CookiePolicy />} />
          <Route path="/legal" element={<LegalNotice />} />
            <Route path="/help" element={<HelpCenter />} />
            <Route path="/help/:id" element={<HelpDetail />} />
            <Route path="/docs" element={<TechnicalDocs />} />
            <Route path="/api" element={<APIDocs />} />
            <Route path="/community" element={<Community />} />
            <Route path="/feedback" element={<Feedback />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Layout>
      
      {/* PWA更新提示 */}
      <PWAUpdatePrompt />
      
      {/* 网络状态检测 */}
      <NetworkStatus />
      
      {/* 全局登录弹窗 */}
      <LoginModal
        isOpen={showLoginModal}
        onClose={() => dispatch(hideLoginModal())}
        onSuccess={() => {
          dispatch(hideLoginModal())
          window.location.reload()
        }}
      />
    </>
  )
}

function App() {
  return <AppContent />
}

export default App